import React, { useState, useCallback, useMemo, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';
import { APP_VERSION } from '../version';
import PublicRicercaPage from './PublicRicercaPage';
import PublicDesktopPage from './PublicDesktopPage';
import { adapterAgente } from './serviziAdapter';
import './publicDashboard.css';

const KEY = 'agenteToken';

export default function AgentePage() {
  const [token, setToken] = useState(() => { try { return localStorage.getItem(KEY) || ''; } catch { return ''; } });
  // 'riallinea' = "Ho cambiato la password su SalesMate": TIM impone il cambio, la password
  // nuova non apre l'app (l'accesso controlla l'impronta in archivio) e la vecchia spesso non
  // si ricorda piu'. Qui si prova quella vera sul sito TIM e si rientra.
  const [modo, setModo] = useState('login');   // 'login' | 'registra' | 'riallinea'
  const [u, setU] = useState(''); const [p, setP] = useState(''); const [nome, setNome] = useState('');
  const [busy, setBusy] = useState(false); const [err, setErr] = useState('');

  // Soglia larga: sotto non c'e' spazio per la rail degli strumenti e le due colonne.
  const [grande, setGrande] = useState(() => typeof window !== 'undefined' && window.innerWidth >= 1000);
  useEffect(() => {
    const m = window.matchMedia('(min-width: 1000px)');
    const cambia = (e) => setGrande(e.matches);
    m.addEventListener('change', cambia);
    return () => m.removeEventListener('change', cambia);
  }, []);

  const salva = (t) => { try { localStorage.setItem(KEY, t); } catch {} setToken(t); };
  const esci = useCallback(() => { try { localStorage.removeItem(KEY); } catch {} setToken(''); }, []);

  const adapter = useMemo(
    () => adapterAgente(() => { try { return localStorage.getItem(KEY) || ''; } catch { return ''; } }, esci),
    [esci]
  );

  const invia = async () => {
    if (!u.trim() || !p) return;
    if (modo === 'registra' && !nome.trim()) { setErr('Inserisci il tuo nome'); return; }
    setBusy(true); setErr('');
    try {
      const body = modo === 'registra'
        ? { username: u.trim(), password: p, nome: nome.trim() }
        : { username: u.trim(), password: p };
      const rotta = { registra: 'registra', riallinea: 'riallinea-password' }[modo] || 'login';
      const r = await axios.post(`${API}/agente/${rotta}`, body);
      salva(r.data.token);
    } catch (e) {
      setErr(e.response?.data?.detail || 'Errore, riprova');
    } finally { setBusy(false); }
  };

  // Manifest dedicato SUBITO, anche prima dell'accesso: chi aggiunge l'app alla schermata
  // Home lo fa quasi sempre dalla pagina di login, e li' PublicRicercaPage - dove viveva lo
  // scambio - non e' ancora montata. Con il manifest predefinito (scope "/m") l'app nasce
  // col perimetro del Centralino e /agente ne resta FUORI: al tap sulla notifica iOS non
  // riusa la finestra aperta, ne apre una seconda.
  useEffect(() => {
    const el = document.querySelector('link[rel="manifest"]');
    const prec = el ? el.getAttribute('href') : null;
    if (el) el.setAttribute('href', '/manifest-agente.json');
    const tit = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    const precTit = tit ? tit.getAttribute('content') : null;
    if (tit) tit.setAttribute('content', 'Agente');
    return () => {
      if (el && prec) el.setAttribute('href', prec);
      if (tit && precTit) tit.setAttribute('content', precTit);
    };
  }, []);

  if (token) {
    // Stessa area agente, due vesti: sullo schermo grande la console desktop, sul telefono
    // l'interfaccia di sempre. La scelta segue il ridimensionamento della finestra, non e'
    // decisa una volta sola all'apertura: chi stringe il browser torna alla veste stretta.
    return grande
      ? <PublicDesktopPage adapter={adapter} />
      : <PublicRicercaPage adapter={adapter} />;
  }

  return (
    <div className="pubdash">
      <div className="bg" />
      <div className="wrap" style={{ maxWidth: 420 }}>
        <div className="logo" style={{ margin: '10vh auto 16px' }}><svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#dfe8ff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2 4 6v6c0 5 3.4 7.5 8 10 4.6-2.5 8-5 8-10V6z" /><path d="m9 12 2 2 4-4" /></svg></div>
        <h2 style={{ textAlign: 'center', margin: '0 0 4px' }}>Area agente</h2>
        <p style={{ textAlign: 'center', color: 'var(--muted)', fontSize: 13, margin: '0 0 20px' }}>
          {modo === 'registra' ? 'Registrati con le tue credenziali SalesMate (verranno validate una volta).'
            : modo === 'riallinea' ? 'Scrivi la password NUOVA di SalesMate: la proviamo sul sito TIM e ti facciamo rientrare. Non serve ricordare la vecchia.'
            : 'Accedi con le tue credenziali SalesMate.'}
        </p>
        {modo === 'registra' && (
          <input className="in" placeholder="Nome (es. Mario Rossi)" value={nome} onChange={e => setNome(e.target.value)} style={{ marginBottom: 10 }} />
        )}
        <input className="in" placeholder="Username SalesMate" value={u} onChange={e => setU(e.target.value)} autoCapitalize="none" style={{ marginBottom: 10 }} />
        <input className="in" type="password" placeholder={modo === 'riallinea' ? 'Password nuova di SalesMate' : 'Password'} value={p} onChange={e => setP(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') invia(); }} style={{ marginBottom: 12 }} />
        {err && <div style={{ color: 'var(--err)', fontSize: 13, marginBottom: 10 }}>{err}</div>}
        <button className="btn" style={{ width: '100%', background: 'linear-gradient(180deg, var(--c456), var(--c456b))', color: 'var(--btn-ink)' }} disabled={busy} onClick={invia}>
          {busy ? (modo === 'riallinea' ? 'Verifico su SalesMate…' : 'Attendere…')
            : modo === 'registra' ? 'Registrati' : modo === 'riallinea' ? 'Aggiorna ed entra' : 'Accedi'}
        </button>
        <div style={{ textAlign: 'center', marginTop: 14, fontSize: 13, color: 'var(--muted)' }}>
          {modo === 'login'
            ? <>Primo accesso? <button className="lnk" onClick={() => { setModo('registra'); setErr(''); }}>Registrati</button></>
            : <>Torna ad <button className="lnk" onClick={() => { setModo('login'); setErr(''); }}>Accedi</button></>}
        </div>
        {modo !== 'riallinea' && (
          <div style={{ textAlign: 'center', marginTop: 8, fontSize: 13, color: 'var(--muted)' }}>
            <button className="lnk" onClick={() => { setModo('riallinea'); setErr(''); }}>Ho cambiato la password su SalesMate</button>
          </div>
        )}
        {/* La versione in chiaro: se qui il numero e' vecchio, il browser sta servendo
            una copia in memoria e le funzioni aggiunte da poco non ci sono ancora. */}
        <div style={{ textAlign: 'center', marginTop: 22, fontSize: 11, color: 'var(--muted)', opacity: .75 }}>
          versione {APP_VERSION}
        </div>
      </div>
    </div>
  );
}
